import { useEffect, useState } from "react";
import "./quoteOrderItem.scss";
import { QuoteOrderItemDetail } from "../QuoteOrderItemDetail/QuoteOrderItemDetail";
import { SortingHeader } from "../../../../../components/Sorting/SortingHeader";
import { SortingProvider } from "../../../../../contexts/SortingContext";
import { formatCurrency, formatDate } from "../../../../../utils/utils";
import { getQuoteListDetails } from "../../../Services/quoteEntryService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { environment } from "../../../../../environments/environment";
import {
  resetQuoteDetails,
  setQuoteDetails,
} from "../../../../../redux/features/quoteEntry/quoteEntrySlice";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

export const QuoteOrderItem = ({ data, onSelect , isLast }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [details, setDetails] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(environment.ElemensPerPage);
  const [search, setSearch] = useState("");
  const [sortingOrder, setSortingOrder] = useState("id");
  // const [body, setBody] = useState([
  //     {
  //       columnName: "company_id",
  //       value: [parseInt(localStorage.getItem("u_company_id"))],
  //     },
  //     {
  //       columnName: "quote_request_id",
  //       value: [data.id],
  //     },
  //   ]);
  const [body, setBody] = useState([]);

  const dispatch = useDispatch();
  const [rfqSelected, setRfqSelected] = useState(false);
  const quoteDetails = useSelector(
    (state) => state.quoteEntry.detailsByQuoteId
  );

  const getDetailsList = async (
    p = page,
    ps = pageSize,
    searchValue = search,
    order = sortingOrder,
    isScroll = false,
    filters = body
  ) => {
    let request = await getQuoteListDetails(p, ps, searchValue, order, filters);

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setDetails([...request.data.load]);
      // dispatch(resetQuoteDetails())
      // dispatch(
      //   setQuoteDetails({ quoteId: data.id, details: [...request.data.load] })
      // );
    }
  };

  const handleSortingChange = (data) => {
    setSortingOrder(data);
  };

  const handleCheckboxChange = async (e) => {
    e.stopPropagation();

    const checked = e.target.checked;
    setRfqSelected(checked);

    if (checked) {
      let updatedDetails = quoteDetails[data.id];

      if (!isOpen && !updatedDetails) {
        const request = await getQuoteListDetails(
          page,
          pageSize,
          search,
          sortingOrder,
          body
        );

        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          updatedDetails = request.data.load;
          dispatch(
            setQuoteDetails({ quoteId: data.id, details: [...updatedDetails] })
          );
        } else {
          updatedDetails = [];
        }
      }

      onSelect(data.id, updatedDetails || []);
    } else {
      onSelect(data.id, null);
    }
  };

  useEffect(() => {
    setBody([
      {
        columnName: "company_id",
        value: [parseInt(localStorage.getItem("u_company_id"))],
      },
      {
        columnName: "quote_request_id",
        value: [data.id],
      },
    ]);
  }, [data.id]);

  // useEffect(()=>{
  //     getDetailsList(0 , pageSize , search , sortingOrder , false , body)

  // } , [sortingOrder])

  useEffect(() => {
    if (isOpen) {
      getDetailsList();
    }
  }, [isOpen]);

  return (
    <SortingProvider
      properties={{
        part_number: "PN",
        description: "Description",
        quantity_required: "QTY To Quote",
        availability: "QTY Quoted",
        lead_days: "Lead Days",
        currency: "Currency",
        unit_cost: "Unit Cost",
        discount_applied: "Discount",
        duty: "Duty",
        freight_cost: "Freight Cost",
        tax_included: "Tax",
        subTotal: "Sub Total",
        total_cost: "Total Cost",
      }}
      onOrderChange={handleSortingChange}
    >
      <section className="quote-entry-order-item">
        <div
          className="quote-entry-item-header"
          onClick={() => setIsOpen(!isOpen)}
          style={{
            position: "relative",
            backgroundColor: rfqSelected ? "#E4FFF3" : isOpen ? "#EFFCFF" : "",
            border: rfqSelected
              ? "1px solid #00CE88"
              : isOpen
              ? "1px solid #B9D8DF"
              : "var(--item-border)",
          }}
        >
          {(data.status === "Pending" ||
            data.status === "Partially Quoted" ||
            data.status === "No Availability") && (
            <FormGroup sx={{ position: "absolute", left: ".48rem" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rfqSelected}
                    onClick={handleCheckboxChange}
                  />
                }
              />
            </FormGroup>
          )}

          <p>{data.id || "--"}</p>
          <p>{data.order_type || "--"}</p>
          <p>{data.location_code || "--"}</p>
          <p>{data.site_code || "--"}</p>
          <p>{formatDate(data.date_sent) || "--"}</p>
          <p>{data.priority || "--"}</p>
          <p>{data.company_name || "--"}</p>
          <p>{data.requested_by || "--"}</p>
          <p>{formatDate(data?.date_required) || "--"}</p>
          <p
            style={{
              textAlign: "end",
            }}
          >
            {formatCurrency(data.total_cost) || "--"}
          </p>
          <button
            style={{
              border:
                data.status == "Pending"
                  ? "1px solid #DFB050"
                  : data.status == "Quoted"
                  ? "1px solid #52D69B"
                  : data.status == "Ordered"
                  ? "1px solid #29ABE2"
                  : data.status == "No Availability"
                  ? "1px solid #F16F6F"
                  : data.status == "Partially Quoted"
                  ? "1px solid #9D84CC"
                  : "",
              backgroundColor:
                data.status == "Pending"
                  ? "#FFF5DF"
                  : data.status == "Quoted"
                  ? "#E4FFF3"
                  : data.status == "Ordered"
                  ? "#EFFCFF"
                  : data.status == "No Availability"
                  ? "#ffebeb"
                  : data.status == "Partially Quoted"
                  ? "#f4f3ff"
                  : "",
              color:
                data.status == "Pending"
                  ? "#DFB050"
                  : data.status == "Quoted"
                  ? "#00CE88"
                  : data.status == "Ordered"
                  ? "#29ABE2"
                  : data.status == "No Availability"
                  ? "#F16F6F"
                  : data.status == "Partially Quoted"
                  ? "#9D84CC"
                  : "",
            }}
            className="item-status-tag"
          >
            {data.status || "--"}
          </button>
        </div>
        <div className={`quote-entry-item-details ${isOpen ? "open" : ""}`}>
          <div className="quote-entry-item-sorting">
            <SortingHeader></SortingHeader>
          </div>
          <div className="quote-entry-item-detail-list">
            {details.length > 0
              ? details.map((detail , idx) => {
                  return (
                    <QuoteOrderItemDetail
                      data={detail}
                      key={detail.id}
                      parentQuoteId={data.id}
                      isLast={isLast}
                      isLastDetail={idx === details.length -  1}
                    ></QuoteOrderItemDetail>
                  );
                })
              : ""}
          </div>
        </div>
      </section>
    </SortingProvider>
  );
};
